import { hot } from 'react-hot-loader'
import React from 'react'
import GroupWebsites from '../components/GroupWebsites/GroupWebsites'

function App() {
  return (
    <>
      <GroupWebsites />
    </>
  )
}

export default hot(module)(App)
